import join from 'url-join';
import { asyncAction, createAction, http } from '../util/';

const api = join(import.meta.env.VITE_API_URL, 'v1');

export const getOrderDeadlinesForAccount = asyncAction({
  baseName: 'GET_ORDER_DEADLINES',
  action: action => values => dispatch => {
    dispatch(action.start(values));
    const param = values.limit ? `?orderWindowCount=${values.limit}` : '';
    return http
      .get(join(api, `order/deadlines/${values.accountNumber}${param}`))
      .then(({ data: response }) =>
        dispatch(
          action.success({
            response,
            accountNumber: values.accountNumber
          })
        )
      )
      .catch(({ message }) => dispatch(action.error({ message, accountNumber: values.accountNumber })));
  }
});

export const selectDeadline = createAction('SELECT_ORDER_WINDOW_DEADLINE');
